/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type RehypeFeesClaimed = {
  rehypeState: Address;
  beneficiary: Address;
  baseAmount: bigint;
  quoteAmount: bigint;
};

export type RehypeFeesClaimedArgs = {
  rehypeState: Address;
  beneficiary: Address;
  baseAmount: number | bigint;
  quoteAmount: number | bigint;
};

export function getRehypeFeesClaimedEncoder(): FixedSizeEncoder<RehypeFeesClaimedArgs> {
  return getStructEncoder([
    ['rehypeState', getAddressEncoder()],
    ['beneficiary', getAddressEncoder()],
    ['baseAmount', getU64Encoder()],
    ['quoteAmount', getU64Encoder()],
  ]);
}

export function getRehypeFeesClaimedDecoder(): FixedSizeDecoder<RehypeFeesClaimed> {
  return getStructDecoder([
    ['rehypeState', getAddressDecoder()],
    ['beneficiary', getAddressDecoder()],
    ['baseAmount', getU64Decoder()],
    ['quoteAmount', getU64Decoder()],
  ]);
}

export function getRehypeFeesClaimedCodec(): FixedSizeCodec<
  RehypeFeesClaimedArgs,
  RehypeFeesClaimed
> {
  return combineCodec(
    getRehypeFeesClaimedEncoder(),
    getRehypeFeesClaimedDecoder(),
  );
}
